import { useQuery } from '@tanstack/react-query'
import { notificationApi } from '../api/client'
import { notificationKeys } from './keys'

export function useNotificationsInbox(pageNumber = 1, pageSize = 20, unreadOnly = false) {
  return useQuery({
    queryKey: notificationKeys.inbox({ pageNumber, pageSize, unreadOnly }),
    queryFn: () => notificationApi.inbox({ pageNumber, pageSize, unreadOnly }),
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  })
}

export function useAlerts(enabled = true) {
  return useQuery({
    queryKey: notificationKeys.alerts(),
    queryFn: () => notificationApi.listAlerts(),
    enabled,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  })
}

export function useOrgDefaults(enabled = true) {
  return useQuery({
    queryKey: notificationKeys.orgDefaults(),
    queryFn: () => notificationApi.getOrgDefaults(),
    enabled,
    staleTime: 60_000,
  })
}
